import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.202 13.746zm.635-.056V9.64h1.602l.252-1.627H8.837v-.889c0-.675.223-1.275.854-1.275h1.016v-1.42H10.7a8.647 8.647 0 00-1.262-.076c-1.49 0-2.363.786-2.363 2.578v1.082H5.544V9.64h1.531v4.036A5.751 5.751 0 018 2.25a5.75 5.75 0 01.837 11.44zM14.75 8a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0z",
    fill: "#000",
    fillOpacity: 0.87
  }));
}
export default SvgComponent;